export const EN = 'en';
